<template>
  <OutSideTitleCard
    v-if="service.payments"
    :title="$t('Payments.Information')"
  >
    <!-- お支払い内容 -->
    <template v-if="service.payments.length > 0">
      <PaymentContent :payment="service.payments[0]" />
    </template>
    <!-- お支払い情報が登録されていない場合 -->
    <template v-else>
      <div class="mt-2">
        {{ $t('Payments.NotRegistered') }}
      </div>
      <v-layout>
        <v-spacer />
        <v-btn
          flat
          color="secondary"
          @click="$router.push({name: 'ManagePayments'})"
        >
          {{ $t('Menu.ManagePayments') }}
        </v-btn>
      </v-layout>
    </template>

    <div class="mt-2">
      <v-divider />
      <div class="mt-3 caption text-grey">
        お支払いはxxx日締め、翌月x日払いです。
      </div>
    </div>
  </OutSideTitleCard>
</template>

<script>
  import { mapGetters } from 'vuex'
  import OutSideTitleCard from '@/components/parts/card/OutSideTitleCard'
  import PaymentContent from '@/components/content/PaymentContent'

  export default {
    components: { PaymentContent, OutSideTitleCard },
    props: {
      service: {
        // available-service/[サービス名] で取得する内容を入れる
        type: Object,
        required: true
      }
    },
    data: () => ({
      isSetPayment: null
    }),
    computed: {
      ...mapGetters(['ui'])
    },
    methods: {
      getSetPayment () {
        this.$http.get()
      }
    }
  }
</script>
